import { Log, Level, Logger } from 'ng2-logger';
import Types, { IAppState, GlobalState } from '../../models/action/core.d';
import {
    ICoursePageSetAction,
    ICoursePageHeaderInfoSetAction,
    IClassActivityProgressSetAction,
    ICourseChangeClassAction,
    ICoursePageSelectedTabAction,
    ICoursePageIncomingActivityAction,
    ICoursePageIncomingActivitySetAction,
    ICoursePageAnnouncementsSetAction,
    ICoursePageCurrentWeekSetAction,
    ICourseContentsWeeksSetAction,
    ICourseContentsWeekActivitiesSetAction,
    ICourseContentsActivirtyCardSetAction,
    IDeleteActivitySetAction,
    IISurveyChoicesSetAction,
    ICourseContentMenuSetAction,
    ICoursePageStudentListAction,
    ICoursePageStudentListSetAction,
    ICoursePageFilesSetAction,
    ICourseClassActivityReportSetAction,
    ICourseClassActivityReportGetAction,
    ICourseAssignmentGradeInformationSetAction,
    ICourseAssignmentStudentListSetAction,
    ICourseAssignmentSaveGradeSetAction,
    ISetMyActivityStats,
    ISetShowAddActivity,
    ISetActivityIdAfterAdd,
    ISetGettingWeeks,
    ISetActId,
    ICourseClassesSetAction,
    IGetProgressPercent,
    ISetActivityFiltersAction,
    ISetActivtyReportDetails,
    ITriggerGetActivities,
    IActivitiesSorting,
    ICourseClassesDataSetAction,
    ISetActivityPassive,
    ICourseContentPassiveButtonAction,
    ISetCourseDefaultView,
    ISetIsClickedWeek,
    ISetGetMoreActivities,
    ISetResetShowMoreCount
} from '../../models/action/coursePage';
import * as Actions from '../constants/coursePage';
import { ILessonPage } from '../../models/pages/coursePage';
import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';
import { ISetMyGrades } from '../../models/action/enrollment';
import { ISetMyVirtualClass } from '../../models/action/virtualClass';
import { ISetMyExams } from '../../models/action/exam';
import { ISetHomeBox } from '../../models/action/messages';
import * as EnrollmentActions from '../constants/enrollment';
import * as VirtualClassActions from '../constants/virtualClass';
import * as ExamActions from '../constants/exam';
import * as AssignmentActions from '../constants/assignment';
import * as MessageActions from '../constants/message';
import * as AnnouncementAction from '../constants/announcement';
import { ISelectedAnnouncementSetAction } from '../../models/action/announcement';
import { ISetMyAssignments } from '../../models/action/assignment';

const _logger = Log.create('Course-Page Reducer');

const setCoursePageData = (newState: any, action: any) => {
    const coursePageAction = action as ICoursePageSetAction;
    newState.coursePageActivityId = coursePageAction.coursePageActivityId;
    newState.coursePageClassId = coursePageAction.coursePageClassId;
    newState.actId = coursePageAction.actId;
    newState.weekOrUnitId = coursePageAction.weekOrUnitId;
    newState.homePageSelectedTab = coursePageAction.homePageSelectedTab;
}

const setGettingWeeks = (newState: any, action: any) => {
    const coursePageAction = action as ISetGettingWeeks;
    newState.isGettingWeeks = coursePageAction.isGettingWeeks;
}

const setActId = (newState: any, action: any) => {
    const coursePageAction = action as ISetActId;
    newState.actId = coursePageAction.actId;
}

const setCoursePageHeaderInformationData = (newState: any, action: any) => {
    const coursePageAction = action as ICoursePageHeaderInfoSetAction;
    newState.coursePageclassInformation = coursePageAction.coursePageclassInformation;
    newState.coursePagefirstTwoTeachers = coursePageAction.coursePagefirstTwoTeachers;
    newState.lessonHeaderIsLoaded = coursePageAction.lessonHeaderIsLoaded;
    newState.courseSortingKey = coursePageAction.coursePageclassInformation!.activityViewType;
}

const setCourseClassActivityProgressData = (newState: any, action: any) => {
    const coursePageAction = action as IClassActivityProgressSetAction;
    newState.activityProgressRecords = coursePageAction.activityProgressRecords;
    newState.activityProgressIsLoaded = coursePageAction.activityProgressIsLoaded;
}

const setCoursePageChangeClass = (newState: any, action: any) => {
    const coursePageAction = action as ICourseChangeClassAction;
    newState.coursePageClassId = coursePageAction.coursePageClassId;
}

const setCourseClasses = (newState: any, action: any) => {
    const coursePageAction = action as ICourseClassesSetAction;
    newState.classes.coursePageActivityId = coursePageAction.coursePageActivityId;
    newState.classes.classes = coursePageAction.classes;
}

const setCourseHomePageSelectedTab = (newState: any, action: any) => {
    const coursePageAction = action as ICoursePageSelectedTabAction;
    newState.homePageSelectedTab = coursePageAction.homePageSelectedTab;
}

const setCourseIncomingActivity = (newState: any, action: any) => {
    const coursePageAction = action as ICoursePageIncomingActivitySetAction;
    newState.incomingActivities = coursePageAction.incomingActivities;
}

const setCoursePageAnnouncements = (newState: any, action: any) => {
    const coursePageAction = action as ICoursePageAnnouncementsSetAction;
    newState.announcements = coursePageAction.announcements;
    newState.announcementIsLoaded = coursePageAction.announcementIsLoaded;
}

const setCoursePassiveActivitiesButton = (newState: any, action: any) => {
    const coursePageAction = action as ICourseContentPassiveButtonAction;
    newState.isPassiveButton = coursePageAction.isPassiveButton;
}

const setCoursePageCourseCurrentWeeks = (newState: any, action: any) => {
    const coursePageAction = action as ICoursePageCurrentWeekSetAction;
        let currentWeekActivities: any;
        if (coursePageAction.currentWeekActivities) {
            currentWeekActivities = coursePageAction.currentWeekActivities;
            newState.currentWeekActivities = currentWeekActivities;
        }
        newState.currentWeekActivitiesIsLoaded = coursePageAction.currentWeekActivitiesIsLoaded;
}

const setCourseContentWeeks = (newState: any, action: any) => {
    const coursePageAction = action as ICourseContentsWeeksSetAction;
    newState.courseContentsWeeks = coursePageAction.courseContentsWeeks;
    newState.courseContentsWeeksLoading = coursePageAction.courseContentsWeeksLoading;
}

const setCoursePageCourseContentsWeeksActivities = (newState: any, action: any, state: any) => {
    const coursePageAction = action as ICourseContentsWeekActivitiesSetAction;

    newState.courseContentWeekActivities = coursePageAction.courseContentWeekActivities;
    newState.activeTabGuid = coursePageAction.activeTabGuid;
    if (coursePageAction.termWeekId !== undefined) {
        newState.weekOrUnitId = coursePageAction.termWeekId;
    }
    if (coursePageAction.isThisWeek) {
        const currentWeekActivities: any = state.currentWeekActivities;
        if (currentWeekActivities) {
            currentWeekActivities.activities = coursePageAction.courseContentWeekActivities;
            newState.currentWeekActivities = currentWeekActivities;
        }
    }
    if (coursePageAction.courseContentWeekActivities && coursePageAction.courseContentWeekActivities.length > 0) {
        newState.actId = coursePageAction.courseContentWeekActivities[0].activityId;
    }
}

const updateOneActivity = (newActivityList: any, _activityCards: any) => {
    if (_activityCards && Array.isArray(_activityCards) && _activityCards.length) {
        newActivityList = newActivityList.map((element: any ) => {
            let newElement = _activityCards.find((x: any) => x.activityId === element.activityId);
            if (newElement) {
                return newElement;
            } else {
                return element;
            }
        });
    }
    return newActivityList;
}

const setCoursePageActivityCards = (newState: any, action: any ) => {
    const coursePageAction = action as ICourseContentsActivirtyCardSetAction;
    if(coursePageAction.spinnerId === "updateOneActivity"){
        let newActivityList = newState.activityCard;
        if(coursePageAction.activityCard){
            const _activityCards: any = coursePageAction.activityCard;
            newActivityList = updateOneActivity(newActivityList, _activityCards);
            newState.activityCard = newActivityList;
        }
        
    }
    else{
        newState.activityCard = coursePageAction.activityCard;
        newState.courseContentActivityCardLoading = coursePageAction.courseContentActivityCardLoading;
    
        // For Filter
        const _activityCards: any = coursePageAction.activityCard;
        if (_activityCards && Array.isArray(_activityCards) && _activityCards.length && _activityCards[0].termWeeksOnFilter && _activityCards[0].termWeeksOnFilter.length) {
            newState.termWeeksOnFilter = _activityCards[0].termWeeksOnFilter;
        } else {
            newState.termWeeksOnFilter = [];
        }
    }
    
}

const setCoursePageActivityFilters = (newState: any, action: any ) => {
    const coursePageAction = action as ISetActivityFiltersAction;
        newState.activityFilters = coursePageAction.activityFilters;
        if (coursePageAction.activityFilters) {
            newState.hasFilter = coursePageAction.activityFilters.hasFilter;
            newState.sort = coursePageAction.activityFilters.sort;
        } else {
            newState.hasFilter = false;
            newState.sort = '-';
        }
}

const setCoursePageActivityCardRefresh = (newState: any, action: any ) => {
    const stateCourseContentActivityCardRefresh = newState.courseContentActivityCardRefresh;
        if (stateCourseContentActivityCardRefresh !== undefined) {
            newState.courseContentActivityCardRefresh = stateCourseContentActivityCardRefresh + 1;
        }
}

const setCoursePageDeleteActivity = (newState: any, action: any ) => {
    const coursePageAction = action as IDeleteActivitySetAction;
    newState.deleteActivityLoading = coursePageAction.deleteActivityLoading;
    newState.deletedActivityId = coursePageAction.deletedActivityId;
    newState.activityCard = coursePageAction.activityCardItems;
    newState.courseContentActivityCardLoading = coursePageAction.courseContentActivityCardLoading;
    newState.courseContentWeekActivitiesLoading = coursePageAction.courseContentWeekActivitiesLoading;
    newState.courseContentWeekActivities = coursePageAction.courseContentWeekActivities;
}

const setSurveyChoices = (newState: any, action: any ) => {
    const coursePageAction = action as IISurveyChoicesSetAction;
    newState.surveyChoices = coursePageAction.surveyChoices;
}

const setCourseContentMenu = (newState: any, action: any ) => {
    const courseContentSetAction = action as ICourseContentMenuSetAction;
    newState.courseContentMenuLoading = courseContentSetAction.courseContentMenuLoading;
    newState.courseContentMenuType = courseContentSetAction.menuType;
    newState.courseContentTermWeeks = courseContentSetAction.termWeeks;
}

const setActivityIdsByWeeks = (newState: any, action: any ) => {
    const courseContentSetAction = action as ICourseContentMenuSetAction;
    newState.activityIdsByWeeks = courseContentSetAction.termWeeks;
}

const setCourseStudentList = (newState: any, action: any ) => {
    const courseStudentListSetAction = action as ICoursePageStudentListSetAction;
    const studentListData = Object.assign(
        {},
        courseStudentListSetAction.results,
        courseStudentListSetAction.filters
    );
    newState.courseStudentList = studentListData;
}

const setCourseFiles = (newState: any, action: any ) => {
    const courseFilesSetAction = action as ICoursePageFilesSetAction;
    const courseFilesData = Object.assign({}, courseFilesSetAction.results, courseFilesSetAction.filters);
    newState.courseFiles = courseFilesData;
}

const setCourseClassActivityReport = (newState: any, action: any ) => {
    const courseContentSetAction = action as ICourseClassActivityReportSetAction;
    newState.classActivityReport = courseContentSetAction.stats;
}

const setCourseAssignmentGradeInfo = (newState: any, action: any ) => {
    const courseContentSetAction = action as ICourseAssignmentGradeInformationSetAction;
    const gradeInformation = courseContentSetAction.gradeInformation;
    newState.assignmentGradeInformation = gradeInformation;
}

const setCourseAssignmentStudentList = (newState: any, action: any ) => {
    const courseContentSetAction = action as ICourseAssignmentStudentListSetAction;
    const result = courseContentSetAction.result;
    newState.assignmentGradeStudentList = result;
}

const setAssignmentSaveGrade = (newState: any, action: any ) => {
    const courseContentSetAction = action as ICourseAssignmentSaveGradeSetAction;
    newState.assignmentGradeSaveResult = courseContentSetAction.result;
}

const setMyVirtualClass = (newState: any, action: any ) => {
    const virtualClassPageAction = (action as ISetMyVirtualClass);
        if (virtualClassPageAction.isLastActivity) {
            if (virtualClassPageAction.MyVirtualClass && virtualClassPageAction.MyVirtualClass.length > 0) {
                newState.myVirtualClass = virtualClassPageAction.MyVirtualClass.concat(newState.myVirtualClass);
            }
        } else {
            newState.myVirtualClass = virtualClassPageAction.MyVirtualClass;
        }
}

const setMyExams = (newState: any, action: any ) => {
    const examPageAction = (action as ISetMyExams);
        if (examPageAction.isLastActivity) {
            if (examPageAction.MyExams && examPageAction.MyExams.length > 0) {
                newState.myExams = examPageAction.MyExams.concat(newState.myExams);
            }
        } else {
            newState.myExams = examPageAction.MyExams;
        }
}

const setMyAssignments = (newState: any, action: any ) => {
    const assignmentPageAction = (action as ISetMyAssignments);
        if (assignmentPageAction.isLastActivity) {
            if (assignmentPageAction.MyAssignments && assignmentPageAction.MyAssignments.length > 0) {
                newState.myAssignments = assignmentPageAction.MyAssignments.concat(newState.myAssignments);
            }
        } else {
            newState.myAssignments = assignmentPageAction.MyAssignments;
        }
}

const setMyGrades = (newState: any, action: any ) => {
    const myGradesSetAction = (action as ISetMyGrades);
        if (myGradesSetAction.IsLastActivity) {
            if (myGradesSetAction.MyGrades && myGradesSetAction.MyGrades.length > 0) {
                newState.myGrades = myGradesSetAction.MyGrades.concat(newState.myGrades);
            }
        } else {
            newState.myGrades = myGradesSetAction.MyGrades;
        }
}

const setMyActivityStats = (newState: any, action: any ) => {
    const myActivitySetAction = (action as ISetMyActivityStats);
    newState.myActivityStats = myActivitySetAction.MyActivityStats;
}

const setMyHomeBox = (newState: any, action: any ) => {
    const homeBoxMessages = (action as ISetHomeBox);
        if (homeBoxMessages.isLastMessage) {
            if (homeBoxMessages.HomeBoxMessages && homeBoxMessages.HomeBoxMessages.length > 0) {
                newState.myMessages = homeBoxMessages.HomeBoxMessages.concat(newState.myMessages); // state güncelleniyor ancak data arayüze gelmiyor.
            }
        } else {
            newState.myMessages = homeBoxMessages.HomeBoxMessages;
        }
}

const setSelectedAnnouncement = (newState: any, action: any, state: any ) => {
    const announcementPageAction = (action as ISelectedAnnouncementSetAction);
        if (announcementPageAction.announcementIndex) {
            if (state.announcements.length > 0) {
                newState.announcements = state.announcements;
                newState.announcements[announcementPageAction.announcementIndex].isRead = true;
            }
        }
}

const coursePageReducer = (state = GlobalState().coursePage, action: Types.IAction) => {
    if (!state) {
        return state;
    }

    const newState: any = { ...state };

    switch(action.type){
        case Actions.actions.SET_COURSE_PAGE_DATA:
            setCoursePageData(newState, action);
            break;
        case Actions.actions.SET_GETTING_WEEKS:
            setGettingWeeks(newState, action);
            break;
        case Actions.actions.SET_ACTID:
            setActId(newState, action);
            break;
        case Actions.actions.SET_COURSE_PAGE_HEADERINFORMATOIN_DATA:
            setCoursePageHeaderInformationData(newState, action);
            break;
        case Actions.actions.SET_COURSE_CLASS_ACTIVITY_PROGRESS_DATA:
            setCourseClassActivityProgressData(newState, action);
            break;
        case Actions.actions.SET_COURSE_PAGE_CHANGE_CLASS:
            setCoursePageChangeClass(newState, action);
            break;
        case Actions.actions.SET_COURSE_PAGE_CLASSES:
            setCourseClasses(newState, action);
            break;
        case Actions.actions.SET_COURSE_HOME_PAGE_SELECTED_TAB:
            setCourseHomePageSelectedTab(newState, action);
            break;
        case Actions.actions.SET_COURSE_PAGE_INCOMING_ACTIVITY:
            setCourseIncomingActivity(newState, action);
            break;
        case Actions.actions.SET_COURSE_PAGE_ANNOUNCEMENTS:
            setCoursePageAnnouncements(newState, action);
            break;
        case Actions.actions.SET_COURSE_PAGE_PASSİVE_ACTIVITIES_BUTTON:
            setCoursePassiveActivitiesButton(newState, action);
            break;
        case Actions.actions.SET_COURSE_PAGE_CURRENT_WEEK_ACTIVITIES:
            setCoursePageCourseCurrentWeeks(newState, action);
            break;
        case Actions.actions.SET_COURSE_PAGE_COURSECONTENTS_WEEKS:
            setCourseContentWeeks(newState, action);
            break;
        case Actions.actions.SET_COURSE_PAGE_COURSECONTENTS_WEEKS_ACTIVITIES:
            setCoursePageCourseContentsWeeksActivities(newState, action, state);
            break;
        case Actions.actions.SET_COURSE_PAGE_ACTIVITY_CARDS:
            setCoursePageActivityCards(newState, action);
            break;
        case Actions.actions.SET_ACTIVITY_FILTERS:
            setCoursePageActivityFilters(newState, action);
            break;
        case Actions.actions.SET_COURSE_PAGE_ACTIVITY_CARD_REFRESH:
            setCoursePageActivityCardRefresh(newState, action);
            break;
        case Actions.actions.SET_COURSE_PAGE_DELETE_ACTIVITY:
            setCoursePageDeleteActivity(newState, action);
            break;
        case Actions.actions.SET_SURVEY_CHOICES:
            setSurveyChoices(newState, action);
            break;
        case Actions.actions.SET_COURSE_CONTENT_MENU:
            setCourseContentMenu(newState, action);
            break;
        case Actions.actions.SET_ACTIVITY_IDS_BY_WEEKS:
            setActivityIdsByWeeks(newState, action);
            break;
        case Actions.actions.SET_COURSE_STUDENT_LIST:
            setCourseStudentList(newState, action);
            break;
        case Actions.actions.SET_COURSE_FILES:
            setCourseFiles(newState, action);
            break;
        case Actions.actions.SET_COURSE_CLASS_ACTIVITY_REPORT:
            setCourseClassActivityReport(newState, action);
            break;
        case Actions.actions.SET_COURSE_ASSIGNMENT_GRADE_INFORMATION:
            setCourseAssignmentGradeInfo(newState, action);
            break;
        case Actions.actions.SET_COURSE_ASSIGNMENT_STUDENT_LIST:
            setCourseAssignmentStudentList(newState, action);
            break;
        case Actions.actions.SET_COURSE_ASSIGNMENT_SAVE_GRADE:
            setAssignmentSaveGrade(newState, action);
            break;
        case VirtualClassActions.actions.SET_MY:
            setMyVirtualClass(newState, action);
            break;
        case ExamActions.actions.SET_MY_EXAMS:
            setMyExams(newState, action);
            break;
        case AssignmentActions.actions.SET_MY_ASSIGNMENTS:
            setMyAssignments(newState, action);
            break;

    }  
    
    if (action.type === EnrollmentActions.actions.SET_MY_GRADES) {
        setMyGrades(newState, action);
    } else if (action.type === Actions.actions.SET_MY_ACTIVITY_STATS) {
        setMyActivityStats(newState, action);
    } else if (action.type === MessageActions.actions.SET_HOME_BOX) {
        setMyHomeBox(newState, action);
    } else if (action.type === AnnouncementAction.actions.SET_SELECTED_ANNOUNCEMENT) {
        setSelectedAnnouncement(newState, action, state);

    } else if (action.type === Actions.actions.SET_SHOW_ADD_ACTIVITY) {
        const pageAction = (action as ISetShowAddActivity);
        newState.isShowActivityAdd = pageAction.isShowActivityAdd;
    } else if (action.type === Actions.actions.SET_ACTIVITY_STATUS) {
        const pageAction = (action as ISetActivityPassive);
        newState.activityId = pageAction.activityId;
        newState.status = pageAction.status;
    }
    else if (action.type === Actions.actions.SET_ACTIVITY_ID_AFTER_ADD) {
        const pageAction = (action as ISetActivityIdAfterAdd);
        newState.activityIdAfterAdd = pageAction.activityId;
        newState.activityFilters = {
            selectedActivityTypes: [],
            searchedText: '',
            sort: '-',
            hasFilter: false
        };
        newState.hasFilter = false;
        newState.sort = '-';
    } else if (action.type === Actions.actions.SET_PROGRESS_PERCENT) {
        const progressPercent = (action as IGetProgressPercent);
        newState.progress = progressPercent.progress;
    } else if (action.type === Actions.actions.ACTIVITY_REPORT_DETAIL_SET_ACTION) {
        const pageAction = (action as ISetActivtyReportDetails);
        newState.ActivityReportDetail = pageAction.ActivityReportDetail;
    } else if (action.type === Actions.actions.SET_SORTING_ACTIVITIES_ACTION) {
        const pageAction = (action as IActivitiesSorting);
        newState.courseSortingKey = pageAction.sortingKey;
    }
    else if (action.type === Actions.actions.SET_COURSE_CLASSES_DATA) {
        const pageAction = (action as ICourseClassesDataSetAction);
        newState.userMyClasses = pageAction.userMyClasses;
    }
    else if (action.type === Actions.actions.SET_COURSE_DEFAULT_VİEW) {
        const pageAction = (action as ISetCourseDefaultView);
        newState.courseDefaultView = pageAction.courseDefaultView;
    }
    else if(action.type === Actions.actions.SET_IS_CLICKED_WEEK){
        const courseContentSetAction = action as ISetIsClickedWeek;
        newState.isClickedWeek = courseContentSetAction.isClickedWeek;
        
    }
    else if(action.type === Actions.actions.SET_GET_MORE_ACTIVITIES){
        const courseContentSetAction = action as ISetGetMoreActivities;
        newState.getMoreActivities = courseContentSetAction.getMoreActivities;
        
    }
    else if(action.type === Actions.actions.SET_RESET_SHOW_MORE_COUNT){
        const courseContentSetAction = action as ISetResetShowMoreCount;
        
        newState.resetShowMoreCount = courseContentSetAction.resetShowMoreCount;
        
    }

    const persistCourseConfig = {
        key: 'course-page',
        storage,
    };

    return Object.assign({}, state, newState);
};
export default coursePageReducer;
